import React from "react";
import { Row, Button, Col, Input, Form, Divider} from "antd";
import imgEdificio from "../../../img/edificio.svg";
import * as etiquetas from '../../../ApplicationResources';
import InputText from "../../interfaz/InputText";
import Select, { Option } from "../../interfaz/Select";

class JuntaEjecutivaModifica extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            existenCambios : false
        };
    }

    /**
     * Se ejecuta antes del renderizado
     */
    componentWillMount() {
        // Si no se han cargado los municipios, los consultamos del ws
        if(this.props.municipios === undefined)
            this.props.consultarMunicipios();
    }

    /**
     * Se ejecuta después del renderizado
     */
    componentDidMount() {
        // Seteamos la información obtenida de la junta distrital ejecutiva en los campos del formulario
        if(this.props.informacionJunta)
            this.props.form.setFieldsValue({
                'txtNombreJunta' : this.props.informacionJunta.nombreJunta,
                'txtCalle' : this.props.informacionJunta.calle,
                'txtNumeroExterior' : this.props.informacionJunta.numeroExterior,
                'txtNumeroInterior' : this.props.informacionJunta.numeroInterior,
                'txtColonia' : this.props.informacionJunta.colonia,
                'txtCodigoPostal' : this.props.informacionJunta.codigoPostal,
                'cmbMunicipio' : this.props.informacionJunta.idMunicipio,
                'txtReferencias' : this.props.informacionJunta.referencias,
                'txtTratamiento' : this.props.informacionJunta.tratamiento,
                'txtNombres' : this.props.informacionJunta.nombres,
                'txtPrimerApellido' : this.props.informacionJunta.primerApellido,
                'txtSegundoApellido' : this.props.informacionJunta.segundoApellido,
                'txtCorreo' : this.props.informacionJunta.correo,
                'txtTelefono' : this.props.informacionJunta.telefono,
                'txtExtension' : this.props.informacionJunta.extension
            });
    }

    /**
     * Permite validar si existen cambios en los campos del formulario
     */
    validacionCambios = () => {
        var existenCambios = false;
        // Validamos si estamos en modificación de datos, si hay información de la junta
        if(this.props.informacionJunta) {
            if(this.props.informacionJunta.calle !== this.props.form.getFieldValue('txtCalle')
            || this.props.informacionJunta.numeroExterior !== this.props.form.getFieldValue('txtNumeroExterior')
            || this.props.informacionJunta.numeroInterior !== this.props.form.getFieldValue('txtNumeroInterior')
            || this.props.informacionJunta.colonia !== this.props.form.getFieldValue('txtColonia')
            || this.props.informacionJunta.codigoPostal !== this.props.form.getFieldValue('txtCodigoPostal')
            || this.props.informacionJunta.idMunicipio !== this.props.form.getFieldValue('cmbMunicipio')
            || this.props.informacionJunta.referencias !== this.props.form.getFieldValue('txtReferencias')
            || this.props.informacionJunta.tratamiento !== this.props.form.getFieldValue('txtTratamiento')
            || this.props.informacionJunta.nombres !== this.props.form.getFieldValue('txtNombres')
            || this.props.informacionJunta.primerApellido !== this.props.form.getFieldValue('txtPrimerApellido')
            || this.props.informacionJunta.segundoApellido !== this.props.form.getFieldValue('txtSegundoApellido')
            || this.props.informacionJunta.correo !== this.props.form.getFieldValue('txtCorreo')
            || this.props.informacionJunta.telefono !== this.props.form.getFieldValue('txtTelefono')
            || this.props.informacionJunta.extension !== this.props.form.getFieldValue('txtExtension')
            )
            existenCambios = true;   
        } else
            existenCambios = true;

        this.setState({ existenCambios : existenCambios});
    }

    /**
     * Llamará la función para almacenar la información de la junta ejecutiva
     */
    onClickBtnGuardar = () => {
        // Validamos los campos del formulario
        this.props.form.validateFields(async(err, values) => {
            if(!err) {
                this.props.guardarInformacionJuntaDistrital(
                    this.props.form.getFieldValue('txtCalle'),
                    this.props.form.getFieldValue('txtNumeroExterior'),
                    this.props.form.getFieldValue('txtNumeroInterior'),
                    this.props.form.getFieldValue('txtColonia'),
                    this.props.form.getFieldValue('txtCodigoPostal'),
                    this.props.form.getFieldValue('cmbMunicipio'),
                    this.props.form.getFieldValue('txtReferencias'),
                    this.props.form.getFieldValue('txtTratamiento'),
                    this.props.form.getFieldValue('txtNombres'),
                    this.props.form.getFieldValue('txtPrimerApellido'),
                    this.props.form.getFieldValue('txtSegundoApellido'),
                    this.props.form.getFieldValue('txtCorreo'),
                    this.props.form.getFieldValue('txtTelefono'),
                    this.props.form.getFieldValue('txtExtension')
                );
            }
        });
    }

    render() {
        return(
            <Form>
                <Col xs={24} sm={24} md={24} lg={24} className="columna2_junta_ejecutiva">
                    <Row>
                        <Col xs={24} sm={24} md={24} lg={24} className="columna2_nombres_campos">
                            {etiquetas.ETIQUETA_JUNTA_EJECUTIVA_NOMBRE_JUNTA}
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={24} className="columna2_nombre_junta_ejecutiva">
                            {this.props.informacionJunta ? this.props.informacionJunta.nombreJunta : ''}
                        </Col>
                    </Row>
                    <Divider>{etiquetas.ETIQUETA_JUNTA_EJECUTIVA_DOMICILIO}</Divider>
                    <Row gutter={10}>
                        <Col xs={16} sm={16} md={16} lg={16}>
                            <InputText nombre="txtCalle"
                                onBlur={this.validacionCambios}
                                placeholder={etiquetas.ETIQUETA_JUNTA_EJECUTIVA_CALLE}
                                form={this.props.form}
                                inputType='text'
                                required={true}
                                msjRequerido={etiquetas.general_dato_requerido}
                                maxLength={60}
                            />
                        </Col>
                        <Col xs={8} sm={8} md={8} lg={8}>
                            <InputText nombre="txtNumeroExterior"
                                onBlur={this.validacionCambios}
                                placeholder={etiquetas.ETIQUETA_JUNTA_EJECUTIVA_NUMERO_EXTERIOR}
                                form={this.props.form}
                                inputType='text'
                                required={true}
                                msjRequerido={etiquetas.general_dato_requerido}
                                maxLength={20}
                            />
                        </Col>
                    </Row>

                    <Row gutter={10}>
                        <Col xs={8} sm={8} md={8} lg={8}>
                            <InputText nombre="txtNumeroInterior"
                                onBlur={this.validacionCambios}
                                placeholder={etiquetas.ETIQUETA_JUNTA_EJECUTIVA_NUMERO_INTERIOR}
                                form={this.props.form}
                                inputType='text'
                                required={false}
                                msjRequerido={etiquetas.general_dato_requerido}
                                maxLength={20}
                            />
                        </Col>
                        <Col xs={8} sm={8} md={8} lg={8}>
                            <InputText nombre="txtColonia"
                                onBlur={this.validacionCambios}
                                placeholder={etiquetas.ETIQUETA_JUNTA_EJECUTIVA_COLONIA}
                                form={this.props.form}
                                inputType='text'
                                required={true}
                                msjRequerido={etiquetas.general_dato_requerido}
                                maxLength={50}
                            />
                        </Col>
                        <Col xs={8} sm={8} md={8} lg={8}>
                            <InputText nombre="txtCodigoPostal"
                                onBlur={this.validacionCambios}
                                placeholder={etiquetas.ETIQUETA_JUNTA_EJECUTIVA_CODIGO_POSTAL}
                                form={this.props.form}
                                inputType='text'
                                required={true}
                                msjRequerido={etiquetas.general_dato_requerido}
                                maxLength={6}
                                rules={[{
                                    max: 6
                                    , pattern: etiquetas.REGEX_FORMATO_SOLO_DIGITOS
                                }]}
                            />
                        </Col>
                    </Row>

                    <Row gutter={10}>
                        <Col xs={8} sm={8} md={8} lg={8}>
                            <Select nombre='cmbMunicipio'
                                onChange={this.validacionCambios}
                                placeholder={etiquetas.ETIQUETA_JUNTA_EJECUTIVA_MUNICIPIO}
                                form={this.props.form}
                                required={true}
                                msjRequerido={etiquetas.general_dato_requerido}
                                rules={[{type: 'number'}]}
                                showSearch={true}
                            >
                                {
                                    this.props.municipios &&
                                    this.props.municipios.map((municipio, index) => (
                                        <Option key={index} value={municipio.idMunicipio}>{municipio.nombreMunicipio}</Option>
                                    ))
                                }
                            </Select>
                        </Col>
                        <Col xs={16} sm={16} md={16} lg={16}>
                            <InputText nombre="txtReferencias"
                                onBlur={this.validacionCambios}
                                placeholder={etiquetas.ETIQUETA_JUNTA_EJECUTIVA_REFERENCIAS}
                                form={this.props.form}
                                inputType='text'
                                required={false}
                                msjRequerido={etiquetas.general_dato_requerido}
                                maxLength={200}
                            />
                        </Col>
                    </Row>

                    <Divider>{etiquetas.ETIQUETA_JUNTA_EJECUTIVA_RESPONSABLE}</Divider>

                    <Row gutter={10}>
                        <Col xs={8} sm={8} md={8} lg={8}>
                            <InputText nombre="txtTratamiento"
                                onBlur={this.validacionCambios}
                                placeholder={etiquetas.ETIQUETA_JUNTA_EJECUTIVA_TRATAMIENTO}
                                form={this.props.form}
                                inputType='text'
                                required={true}
                                msjRequerido={etiquetas.general_dato_requerido}
                                maxLength={20}
                                rules={[{
                                    max: 20
                                    , pattern: etiquetas.REGEX_FORMATO_NO_CARACTERES_ESPECIALES
                                }]}
                            />
                        </Col>
                        <Col xs={8} sm={8} md={8} lg={8}>
                            <InputText nombre="txtNombres"
                                onBlur={this.validacionCambios}
                                placeholder={etiquetas.ETIQUETA_JUNTA_EJECUTIVA_NOMBRES}
                                form={this.props.form}
                                inputType='text'
                                required={true}
                                msjRequerido={etiquetas.general_dato_requerido}
                                maxLength={50}
                                rules={[{
                                    max: 50
                                    , pattern: etiquetas.REGEX_FORMATO_NO_CARACTERES_ESPECIALES
                                }]}
                            />
                        </Col>
                        <Col xs={8} sm={8} md={8} lg={8}>
                            <InputText nombre="txtPrimerApellido"
                                onBlur={this.validacionCambios}
                                placeholder={etiquetas.ETIQUETA_JUNTA_EJECUTIVA_PRIMER_APELLIDO}
                                form={this.props.form}
                                inputType='text'
                                required={!this.props.form.getFieldValue("txtSegundoApellido")}
                                msjRequerido={etiquetas.general_dato_requerido}
                                maxLength={50}
                                rules={[{
                                    max: 50
                                    , pattern: etiquetas.REGEX_FORMATO_NO_CARACTERES_ESPECIALES
                                }]}
                            />
                        </Col>
                    </Row>

                    <Row gutter={10}>
                        <Col xs={6} sm={6} md={6} lg={6}>
                            <InputText nombre="txtSegundoApellido"
                                onBlur={this.validacionCambios}
                                placeholder={etiquetas.ETIQUETA_JUNTA_EJECUTIVA_SEGUNDO_APELLIDO}
                                form={this.props.form}
                                inputType='text'
                                required={!this.props.form.getFieldValue("txtPrimerApellido")}
                                msjRequerido={etiquetas.general_dato_requerido}
                                maxLength={50}
                                rules={[{
                                    max: 50
                                    , pattern: etiquetas.REGEX_FORMATO_NO_CARACTERES_ESPECIALES
                                }]}
                            />
                        </Col>
                        <Col xs={6} sm={6} md={6} lg={6}>
                            <InputText nombre="txtCorreo"
                                onBlur={this.validacionCambios}
                                placeholder={etiquetas.ETIQUETA_JUNTA_EJECUTIVA_CORREO_ELECTRONICO}
                                form={this.props.form}
                                inputType='text'
                                required={true}
                                msjRequerido={etiquetas.general_dato_requerido}
                                maxLength={50}
                                rules={[{
                                    type: 'email',
                                    max: 50
                                    , pattern: etiquetas.REGEX_FORMATO_CORREO
                                }]}
                            />
                        </Col>
                        <Col xs={6} sm={6} md={6} lg={6}>
                            <InputText nombre="txtTelefono"
                                onBlur={this.validacionCambios}
                                placeholder={etiquetas.ETIQUETA_JUNTA_EJECUTIVA_TELEFONO_MODIFICA}
                                form={this.props.form}
                                inputType='text'
                                required={true}
                                msjRequerido={etiquetas.general_dato_requerido}
                                maxLength={15}
                                rules={[{
                                    max: 15
                                    , pattern: etiquetas.REGEX_FORMATO_SOLO_DIGITOS
                                }]}
                            />
                        </Col>
                        <Col xs={6} sm={6} md={6} lg={6}>
                            <InputText nombre="txtExtension"
                                onBlur={this.validacionCambios}
                                placeholder={etiquetas.ETIQUETA_JUNTA_EJECUTIVA_EXTENSION}
                                form={this.props.form}
                                inputType='text'
                                required={false}
                                msjRequerido={etiquetas.general_dato_requerido}
                                maxLength={10}
                                rules={[{
                                    max: 10
                                    , pattern: etiquetas.REGEX_FORMATO_SOLO_DIGITOS
                                }]}
                            />
                        </Col>
                    </Row>
                </Col>

                <Col xs={24} sm={14} md={14} lg={14} offset={10} className='botones_modifica_junta_ejecutiva'>
                    <Row>
                        <Col xs={6} sm={6} md={4} lg={4}>
                            <Button type="primary"
                                onClick = {this.props.onClickBtnCancelar}
                            >
                                {etiquetas.general_btn_cancelar}
                            </Button>
                        </Col>
                        <Col xs={6} sm={6} md={4} lg={4}>
                            <Button type="primary"
                                disabled={!this.state.existenCambios}
                                onClick = {this.onClickBtnGuardar}
                            >
                                {etiquetas.general_btn_guardar}
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Form>
        );
    }
}

const JuntaEjecutivaForm = Form.create({name: 'je_form'})(JuntaEjecutivaModifica);

export default (JuntaEjecutivaForm);